import { INavItem } from "./nav-item.model";

export interface INavMenu {
  userName: string;
  email: string;
  tenantId: number;
  applicationName: string;
  navItems: INavItem[];
}

export enum MenuEnum {
  None = 0,
  Clinical = 1,
  Admin = 2,
  CustomerSystemAdministrator = 3
}
